import React from 'react';
import '../styles/modals.css'; // Optional: Separate CSS file for styling

// Define the types for the props
interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message: React.ReactNode;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ isOpen, onClose, onConfirm, message }) => {
  if (!isOpen) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <p>{message}</p>
        <div className="modal-actions">
          <button onClick={onConfirm} className="button confirm">Yes</button>
          <button onClick={onClose} className="button cancel">No</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
